import LayoutVerificarAssinatura from '../../componentes/LayoutVerificarAssinatura.vue';
import VerificarAssinaturas from './VerificarAssinaturas.vue';

export default {
  path: '/verificar-assinaturas',
  component: LayoutVerificarAssinatura,
  children: [
    {
      path: '',
      component: VerificarAssinaturas,
      name: 'verificar.assinatura',
    },
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/verificar-assinaturas/rotas.js